module.exports = __webpack_public_path__ + "assets/images/02-full_c45002268a6b40db6cd94285c1273ef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/02-full.png
// module id = 161
// module chunks = 0